import axios from 'axios';
import { AttributeType, SellerAttribute } from '../types/attribute.types';

const BASE = process.env.REACT_APP_API_URL;
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export interface AttributeListResponse {
    attributes: SellerAttribute[];
    total     : number;
    page      : number;
    pages     : number;
}

export const attributeService = {

    getAttributes: (params: Record<string, any>, token: string) =>
        axios.get<AttributeListResponse>(`${BASE}/seller/attributes`, { ...auth(token), params }),

    createAttribute: (data: { name: string; attributeType: AttributeType; colorHex?: string }, token: string) =>
        axios.post<{ attribute: SellerAttribute }>(`${BASE}/seller/attributes`, data, auth(token)),

    updateAttribute: (id: string, data: Partial<{ name: string; colorHex: string; status: string }>, token: string) =>
        axios.put<{ attribute: SellerAttribute }>(`${BASE}/seller/attributes/${id}`, data, auth(token)),

    deleteAttribute: (id: string, token: string) =>
        axios.delete(`${BASE}/seller/attributes/${id}`, auth(token)),

    toggleStatus: (id: string, status: 'ACTIVE' | 'INACTIVE', token: string) =>
        axios.patch(`${BASE}/seller/attributes/${id}/status`, { status }, auth(token)),
};
